import { InvoiceDetail } from './invoice-detail';

export class Invoice {
  InvoiceId: string;
  IsPaid: boolean;
  IsRefunded: boolean;
  Name: string;
  SubTotal: number;
  Fst: number;
  Pst: number;
  Total: number;
  Balance: number;
  InvoiceDetails: InvoiceDetail[];
  IsDonation: boolean;
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/models/invoice.ts